module.exports = __webpack_public_path__ + "img/134.09d9a4d5.jpg";